import store from 'client/store';

export default {
  path: 'dashboard',
  name: 'event.discipline.dashboard',
  component: () => import(/* webpackChunkName: "event" */ './dashboard.vue'),
  beforeEnter: function (to, from, next) {
    store.dispatch("displays.load", {
      eventId: to.params.eventId
    }).then( () => { next(); });
  },
  children: [{
    path: 'session/:sessionId',
    component: () => import(/* webpackChunkName: "event" */ './sessionWrapper.vue'),
    beforeEnter: function (to, from, next) {
      const filter = { sessionId: to.params.sessionId };
      store.dispatch("panels.getBySession", filter).then(() => { next() });
    },
    children: [{
      path: '/',
      name: 'event.discipline.dashboard.session',
      component: () => import(/* webpackChunkName: "event" */ './sessionDashboard.vue'),
    },{
      path: 'block/:panelId/:rotation',
      name: 'event.discipline.dashboard.block',
      component: () => import(/* webpackChunkName: "event" */ './blockDashboard.vue'),
      props: true,
    },{
      path: 'exercise/:panelId/:rotation/:exerciseId/:pass',
      name: 'event.discipline.dashboard.exercise',
      component: () => import(/* webpackChunkName: "event" */ './exercise.vue'),
      beforeEnter: function(to, from, next) {
        store.dispatch('exercise.load', {
          panelId: to.params.panelId,
          exerciseId: to.params.exerciseId,
          pass: parseInt(to.params.pass)
        }).then(() => { next() });
      }
    },{
      path: 'selections/:categoryId/:type/:exerciseTypeId',
      name: 'event.discipline.dashboard.selections',
      component: () => import(/* webpackChunkName: "event" */ './selections.vue'),
      props: true,
    }]
  }]
};
